// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"04309878","917":"ddfc9901"}[chunkId] + ".chunk.js";
};